export default function (value) {
  if (!value) {
    return undefined;
  }

  return [
    {
      value: 'A',
      label: '(A) Agricoltura silvicoltura e pesca',
    },
    {
      value: 'B-C-D',
      label: '(B) Estrazione, (C) manifattura, (D) produzione energia/gas',
    },
    {
      value: 'E-D',
      label: '(E) Forniture acqua reti fognarie e rifiuti, (D) trasmissione energia/gas',
    },
    {
      value: 'F41',
      label: '(F41) Costruzione di edifici',
    },
    {
      value: 'F42-F43',
      label: '(F42) Ingegneria civile,(F43) costruzioni specializzate',
    },
    {
      value: 'G45-G46-D',
      label: '(G45) Commercio autoveicoli,(G46) commercio ingrosso,(D) distribuzione energia/gas',
    },
    {
      value: 'H-I55',
      label: '(H) Trasporto e magazzinaggio,(I55) hotel',
    },
    {
      value: 'JMN',
      label: '(JMN) Servizi alle imprese B2B',
    },
    {
      value: 'PQRS',
      label: '(PQRS) Servizi alle persone',
    },
  ].find(i => i.value === value)?.label;
};
